import { IPayerResponse } from "@wingspanhq/payments/dist/interfaces";

import { servicePayments } from "../servicePayments";

export const getPayer = async (id: string): Promise<IPayerResponse> => {
  const { data } = await servicePayments.get(`/payer/${id}`);
  return data;
};
